import { FC } from 'react';
import TermsOfServiceModalClass from '../../assets/scss/TermsOfServiceModal/TermsOfServiceModal.module.scss';
import { TermsOfServiceModalViewType } from '../../types/view/TermsOfServiceModalViewType';
import { CommonModal } from '../CommonModal';
import { ConfirmTitle } from '../ModalItem/ConfirmTitle';

export const TermsOfServiceModal: FC<{
  active: boolean;
  termsOfServiceModal: TermsOfServiceModalViewType | null;
  closeFunc: () => void;
  loading: boolean;
}> = ({ active, termsOfServiceModal, closeFunc, loading }) => {
  if (!termsOfServiceModal) return <></>;

  let contentTitle = '';
  let contentText = <></>;
  if (termsOfServiceModal.modalType === 'SubscriptionPolicy') {
    contentTitle = '定期購入契約ポリシー';
    contentText = (
      <>
        <p className={TermsOfServiceModalClass.pageDescription}>
          株式会社ZENB JAPAN
          <br />
          注文前に必ずご確認ください。
        </p>
        <ul className={TermsOfServiceModalClass.compContent}>
          <li>
            <span className={TermsOfServiceModalClass.heading}>商品お届けのタイミング</span>
            <p>
              初回は注文日から2日以内に発送します。
              <br />
              2回目以降の注文分は、初回ご注文日を起算点として、既定の頻度で配送します。
            </p>
          </li>
          <li>
            <span className={TermsOfServiceModalClass.heading}>支払方法・請求のタイミング</span>
            <p>
              クレジットカード、デビットカード、PayPalいずれか
              <br />
              請求タイミング：初回は注文確定時、2回目以降はお届け予定日の4日前に請求します。
            </p>
          </li>
          <li>
            <span className={TermsOfServiceModalClass.heading}>商品の変更</span>
            <p>
              2回目以降のお届け商品は、マイアカウント上で好きな商品を1点から追加・変更が可能です。
              <br />
              商品の変更は、送料を除き、商品価格の合計が2,200円（税込）以上から利用できます。
            </p>
          </li>
          <li>
            <span className={TermsOfServiceModalClass.heading}>定期オトク便の停止・解約</span>
            <p>定期オトク便のお届けを止める方法は「停止」と「解約」の２種類あります。</p>
          </li>
          <ul className={TermsOfServiceModalClass.stopType}>
            <li>
              <span className={TermsOfServiceModalClass.heading}>停止</span>
              <p>
                お届け予定日の6日前までに、マイアカウントで停止できます。
                <br />
                停止中はご請求も、商品のお届けも一切発生しません。再開は、マイアカウントでいつでも可能です。
              </p>
            </li>
            <li>
              <span className={TermsOfServiceModalClass.heading}>解約</span>
              <p>
                解約するには、お届け予定日の6日前までに「マイアカウント」で停止した後、「ZENBお客様センター
                お問い合わせフォーム」より解約の連絡をしてください。
                <br />
                <br />
                解約後、解約前の情報を引き継ぐことができません。
              </p>
            </li>
          </ul>
        </ul>
      </>
    );
  } else if (termsOfServiceModal.modalType === 'Payment') {
    contentTitle = '支払い方法と請求のタイミング';
    contentText = (
      <ul>
        <li>
          <span className={TermsOfServiceModalClass.heading}>支払い方法</span>
          <p>クレジットカード、デビットカード、PayPal</p>
        </li>
        <li>
          <span className={TermsOfServiceModalClass.heading}>請求のタイミング</span>
          <p>お届け予定日の4日前に決済されます。</p>
        </li>
      </ul>
    );
  } else if (termsOfServiceModal.modalType === 'ReturnExchange') {
    contentTitle = '商品の返品・交換';
    contentText = (
      <ul>
        <li>
          <span className={TermsOfServiceModalClass.heading}>お客様都合による返品</span>
          <p>
            食品という商品特性上、未使用品であっても、お客様のご希望による返品は承っておりません。
          </p>
        </li>
        <li>
          <span className={TermsOfServiceModalClass.heading}>
            商品の破損や不良品による返品・交換
          </span>
          <p>
            商品の品質には万全の注意を払っておりますが、商品の不良や破損の際は、商品の状況に応じて適切に対応いたします。
            <a
              className={TermsOfServiceModalClass.textLink}
              href="https://support.zenb.jp/hc/ja/requests/new"
              target="_blank"
              rel="noopener noreferrer"
            >
              お問い合わせフォーム
            </a>
            よりご連絡ください。その際、必ず以下の情報をお知らせください。
          </p>
          <ol className={TermsOfServiceModalClass.necessaryInfo}>
            <li>商品の状態</li>
            <li>配送箱への傷、へこみ等の有無</li>
            <li>配送箱に傷、へこみがある場合はどのような状況か</li>
            <li>商品の賞味期限</li>
          </ol>
        </li>
        <li>
          <span className={TermsOfServiceModalClass.heading}>
            注文した商品とは異なる商品が届いた場合の返品・交換
          </span>
          <p>
            <a
              className={TermsOfServiceModalClass.textLink}
              href="https://support.zenb.jp/hc/ja/requests/new"
              target="_blank"
              rel="noopener noreferrer"
            >
              お問い合わせフォーム
            </a>
            よりご連絡ください。
          </p>
        </li>
      </ul>
    );
  }

  const content = (
    <>
      <ConfirmTitle title={contentTitle} />
      <div className={TermsOfServiceModalClass.compBlock}>{contentText}</div>
    </>
  );

  return (
    <CommonModal
      active={active}
      closeFunc={closeFunc}
      loading={loading}
    >
      {content}
    </CommonModal>
  );
};
